import HomeBotoxList from "./pages/HomeBotoxList.vue";

export default {
    HomeBotoxList,
};
